import React from "react";
import ReactDOM from "react-dom";
import "./style.scss";
import App from "./components/App";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
import AlertBoxProvider from "./context/alertBoxContext";

ReactDOM.render(
  <React.Fragment>
    {
      // Componente base es el primero al que se llama al cargar la aplicación
    }
    <BrowserRouter>
      <AlertBoxProvider>
        <App />
      </AlertBoxProvider>
    </BrowserRouter>
  </React.Fragment>,
  document.getElementById("root")
);

reportWebVitals();
